import { type Dtos, type SuretyAccountId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { incomeStatementsQueryKey } from "./financials.keys";

export const useFetchIncomeStatements = (accountId: SuretyAccountId) => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();
	const isAdmin = user.type === "admin";

	const { data, error, isFetching, isLoading, refetch } = useQuery({
		queryKey: incomeStatementsQueryKey(accountId),
		queryFn: async () =>
			get<Dtos.Admin.IncomeStatement.List.Response>(
				`/v2/${isAdmin ? "admin/" : ""}surety/accounts/${accountId}/income-statements`,
			),
	});

	return {
		incomeStatements: data,
		incomeStatementsError: error,
		incomeStatementsIsFetching: isFetching,
		incomeStatementsLoading: isLoading,
		refetchIncomeStatements: refetch,
	};
};
